export enum PermissionsEnum {
    Camera,
    Notifications,
}
